module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAONJREFUKBW9UksKwjAQzcR24VXEe1QEb9EuaoV6lUqLFouXEESvId7FRUpiXuiUVsxGwYGSN5+XzswLVVWzUFqvhBCh/WAqlPKcZfEVTlEel0boSBiawhdkniTkLXCkCdXbdXJHvNg3c9Xq1EJHHJFQYC8wpCNpYcgkxPM0fhCZANgZ/4l9nDYG4lcGokJ7zN4dTjNjqGUfM/WYgY0FWARmKsratadV2yLW19hFYKb35XD+fyf5dMo3yQVt+PLyo04QvDNfXvZDcyXOoXZDzDW/6ejRiS/36SjxYEfJ7hEz0Zd/Aay7fgt23ri4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Group.png
// module id = 4cW9
// module chunks = 1